import React from 'react'

function ChangePasswordDetails({setShowEdit}) {
    return (
        <div className='w-full font-plexsans'>
          <h2 style={{margin:'0 0 4px', font:"400 22px/1.25 'Spectral',serif", color:'#14213d'}}>Password &amp; security</h2>
          <p style={{margin:'0 0 26px', font:"400 13.5px/1.5 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.55)'}}>Password has been set. Changing your password requires you to sign in again afterward.</p>
          <button
            className="cursor-pointer rounded-sm transition-colors"
            style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#fffdf8', background:'#8a6231', border:'none', padding:'12px 24px'}}
            onMouseEnter={(e) => e.currentTarget.style.background = '#6d4c25'}
            onMouseLeave={(e) => e.currentTarget.style.background = '#8a6231'}
            onClick = {()=> setShowEdit(true)}>Change password</button>
        </div>
      )
}

export default ChangePasswordDetails
